import React, { Component } from "react";
import Draggable from "react-draggable";
import * as FloorplanActions from './FloorplanActions';
import MarkerComponent from './MarkerComponent';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import clustering from "density-clustering";
import Ink from "react-ink";

class FloorplanComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      touches: 0,
      prevDist: 0,
      notAvailableHeight: 0.167,
      notAvailableWidth: 0.2,
      clusterZoom: false,
      stepClusterZoom: 0,
      zoomEmount: 0
    };

    this.draggableOnStop = this.draggableOnStop.bind(this);
    this.floorplanOnTouchStart = this.floorplanOnTouchStart.bind(this);
    this.floorplanOnTouchEnd = this.floorplanOnTouchEnd.bind(this);
    this.floorplanOnTouchMove = this.floorplanOnTouchMove.bind(this);
    this.onResize = this.onResize.bind(this);
    this.markers = [];
  }

  componentDidMount = () => {
    window.addEventListener("resize", this.onResize, false);
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.orientation != this.props.orientation) {
      setTimeout(this.onResize, 300);
    }
    if (prevProps.activeStage !== this.props.activeStage) {
        this.setState({
            stepClusterZoom: 0,
            zoomEmount: 0
        })
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.onResize, false);
  };

  floorplanOnTouchStart(e) {
    this.setState({
      touches: e.touches.length
    });

    if (e.touches.length > 1) {
      e.preventDefault();
      const dist = Math.hypot(
        e.touches[0].pageX - e.touches[1].pageX,
        e.touches[0].pageY - e.touches[1].pageY
      );

      this.setState({
        prevDist: dist
      });
    }
  }

  floorplanOnTouchEnd(e) {
    this.setState({
      touches: e.touches.length
    });
  }

  floorplanOnTouchMove(e) {
    if (this.state.touches === 2) {
      const dist = Math.hypot(
        e.touches[0].pageX - e.touches[1].pageX,
        e.touches[0].pageY - e.touches[1].pageY
      );

      const pinch = (dist - this.state.prevDist) / this.stageImage.naturalWidth;
      this.changeZoom(pinch, this.stageImage);

      this.setState({
        prevDist: dist
      });
    }
  }

  draggableOnStop(e, data) {
    this.props.draggableOnStop(e, data);
  }

  onResize() {
    this.initialZoom(this.stageImage);
  }

  onZoomCluster = stepClusterZoom => {
    this.changeZoom(stepClusterZoom, this.stageImage);
  };

  setActiveImage = name => {
    this.props.floorplanActions.setActiveSlide(name);
  };

  changeZoom = (value, content) => {
    this.props.floorplanActions.changeZoom(value, content);
    this.setState({
      zoomEmount: this.state.zoomEmount + value
    });
  };

  changeZoom = (value, content) => {
    this.props.floorplanActions.changeZoom(value, content);
    this.setState({
      zoomEmount: this.state.zoomEmount + value
    });
  }

  initialZoom = stageImage => {
    const { floorplanActions } = this.props;
    const { notAvailableHeight, notAvailableWidth } = this.state;
    const { clientWidth, clientHeight } = this.props.container;
    
    const availableHeight = clientHeight - clientHeight * notAvailableHeight;
    const availableWidth = clientWidth - clientWidth * notAvailableWidth;
    const heightZoom = availableHeight / stageImage.naturalHeight;
    const widthZoom = availableWidth / stageImage.naturalWidth;

    const zoomValue = widthZoom < heightZoom ? widthZoom : heightZoom;
    if (window.innerWidth < 933) {
      floorplanActions.setMapPosition(
        (this.props.container.clientWidth -
          stageImage.naturalWidth * zoomValue) /
          2,
        (this.props.container.clientHeight -
          stageImage.naturalHeight * zoomValue) /
          2
      );
    } else {
      floorplanActions.setMapPosition(
        (this.props.container.clientWidth * 1.2 -
          stageImage.naturalWidth * zoomValue) /
          2,
        0
      );
    }
    floorplanActions.setZoom(zoomValue);
  };

  getMarkers = () => {
    const {
      mapPosition,
      zoom,
      imagesPath,
      stages,
      activeStage,
      visitedSlides,
      activeSlideName
    } = this.props;
    const clusterData = [];
    const markersNoise = [];
    stages[activeStage].markers.forEach((marker, i) => {
      clusterData.push([marker.coord_x * zoom, marker.coord_y * zoom]);
    });
    const dbscan = new clustering.DBSCAN();
    // parameters: 5 - neighborhood radius, 2 - number of points in neighborhood to form a cluster
    const clusters = dbscan.run(clusterData, 30, 2);
    const noise = dbscan.noise;
    if (noise.length) {
      noise.forEach((el, i) => {
        markersNoise.push(stages[activeStage].markers[el]);
      });
    }
    const markers = markersNoise.map((marker, i) => {
      let markerClass = "";
      if (visitedSlides.has(marker.file_name)) {
        markerClass = "visited";
      }
      if (activeSlideName === marker.file_name) {
        markerClass = "active";
      }
      return (
        <MarkerComponent
          ref={marker => (this.markers[i] = marker)}
          key={i}
          marker={marker}
          zoom={zoom}
          id={i}
          basePath={imagesPath}
          className={markerClass}
          setActiveImage={this.setActiveImage}
          mapPosition={mapPosition}
        />
      );
    });
    if (clusters.length) {
      const style = {
        position: "absolute",
        zoom: 1 / zoom,
        OTransform: `scale(${1 / zoom})`,
        OTransformOrigin: "left top",
        MozTransform: `scale(${1 / zoom})`,
        MozTransformOrigin: "left top"
      };
      clusters.forEach((cluster, i) => {
        let x = 0;
        let y = 0;
        for (let j = 0; j < cluster.length; j++) {
          x += clusterData[cluster[j]][0];
          y += clusterData[cluster[j]][1];
        }
        const left = x / cluster.length;
        const top = y / cluster.length;
        markers.push(
          <div
            className="marker"
            style={{
              ...style,
              color: "#000",
              left: `${left}px`,
              top: `${top}px`
            }}
            onClick={() => this.onZoomCluster(zoom - this.state.zoomEmount)}
          >
            <div className="wrapperCount">
              <span className="countMarker">{cluster.length}</span>
            </div>
            <i className="fa fa-camera" aria-hidden="true" />
          </div>
        );
      });
    }
    return markers;
  };

  render() {
    const {
      mapPosition,
      zoom,
      imagesPath,
      stages,
      activeStage,
      draggableOnStop,
      zoomStep
    } = this.props;
    return (
      <div>
        <Draggable
          position={{ x: mapPosition.x, y: mapPosition.y }}
          onStop={draggableOnStop}
        >
          <div className="floorplan-map-wrapper">
            <div
              className="floorplan"
              onTouchStart={this.floorplanOnTouchStart}
              onTouchEnd={this.floorplanOnTouchEnd}
              onTouchMove={this.floorplanOnTouchMove}
              style={{
                zoom: zoom,
                OTransform: `scale(${zoom})`,
                OTransformOrigin: "left top",
                MozTransform: `scale(${zoom})`,
                MozTransformOrigin: "left top"
              }}
            >
              <img
                ref={stageImage => (this.stageImage = stageImage)}
                className="stage-image"
                src={imagesPath + stages[activeStage].stageImage}
                alt={stages[activeStage].name}
                onLoad={() => {
                  this.initialZoom(this.stageImage);
                }}
              />
              {this.getMarkers()}
            </div>
          </div>
        </Draggable>
        <div className="zoom" ref={zoom => (this.zoom = zoom)}>
          <button
            className="btn btn-transparent"
            onClick={() => this.changeZoom(zoomStep, this.stageImage)}
          >
            <Ink />
            <i className="fa fa-plus-circle" aria-hidden="true" />
          </button>
          <button
            className="btn btn-transparent"
            onClick={() => this.changeZoom(-zoomStep, this.stageImage)}
          >
            <Ink />
            <i className="fa fa-minus-circle" aria-hidden="true" />
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    imagesPath: state.floorplan.imagesPath,
    stages: state.floorplan.stages,
    activeStage: state.floorplan.activeStage,
    activeSlideName: state.floorplan.activeSlideName,
    mapPosition: state.floorplan.mapPosition,
    zoom: state.floorplan.zoom,
    zoomStep: state.floorplan.zoomStep,
    visitedSlides: state.floorplan.visitedSlides
  };
};

const mapDispatchToProps = dispatch => {
  return {
    floorplanActions: bindActionCreators(FloorplanActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FloorplanComponent);
